<div class="order-filters-container">
  <div class="filter-header">
    <h2 class="filter-title">Filter by</h2>
  </div>

  <!-- Weight Filter -->
  <div class="filter-block">
    <div class="filter-block-header">
      <span class="filter-label">Weight (Kg)</span>
      <button class="reset-link" (click)="resetWeight()" *ngIf="weightMin !== weightSliderMin || weightMax !== weightSliderMax">Reset</button>
    </div>
    <div class="range-inputs-container">
      <div class="range-fill" [style.background]="getWeightSliderBackground()"></div>
      <input
        type="range"
        class="range-input start-range"
        [min]="weightSliderMin"
        [max]="weightSliderMax"
        [step]="1"
        [value]="weightMin"
        (input)="onWeightMinChange($event)"
      />
      <input
        type="range"
        class="range-input end-range"
        [min]="weightSliderMin"
        [max]="weightSliderMax"
        [step]="1"
        [value]="weightMax"
        (input)="onWeightMaxChange($event)"
      />
    </div>
    <div class="slider-labels">
      <span class="slider-value">{{ weightMin }} Kg</span>
      <span class="slider-value">{{ weightMax }} Kg</span>
    </div>
    <div class="filter-separator"></div>
  </div>

  <!-- Capacity Filter -->
  <div class="filter-block">
    <div class="filter-block-header">
      <span class="filter-label">Capacity (Cbm)</span>
      <button class="reset-link" (click)="resetCapacity()" *ngIf="capacityMin !== capacitySliderMin || capacityMax !== capacitySliderMax">Reset</button>
    </div>
    <div class="range-inputs-container">
      <div class="range-fill" [style.background]="getCapacitySliderBackground()"></div>
      <input
        type="range"
        class="range-input start-range"
        [min]="capacitySliderMin"
        [max]="capacitySliderMax"
        [step]="1"
        [value]="capacityMin"
        (input)="onCapacityMinChange($event)"
      />
      <input
        type="range"
        class="range-input end-range"
        [min]="capacitySliderMin"
        [max]="capacitySliderMax"
        [step]="1"
        [value]="capacityMax"
        (input)="onCapacityMaxChange($event)"
      />
    </div>
    <div class="slider-labels">
      <span class="slider-value">{{ capacityMin }} Cbm</span>
      <span class="slider-value">{{ capacityMax }} Cbm</span>
    </div>
    <div class="filter-separator"></div>
  </div>

  <!-- Delivery Date Filters -->
  <div class="filter-block">
    <div class="filter-block-header">
      <span class="filter-label">Delivery on or before date</span>
    </div>
    <div class="date-filters-container">
      <div class="date-picker-row">
        <mat-form-field appearance="outline" class="date-picker-field">
          <input
            matInput
            [matDatepicker]="beforePicker"
            [formControl]="deliveryOnOrBeforeDateControl"
            placeholder="DD-MM-YYYY"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="beforePicker"></mat-datepicker-toggle>
          <mat-datepicker #beforePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="filter-separator"></div>
  </div>

  <div class="filter-block">
    <div class="filter-block-header">
      <span class="filter-label">Delivery on or after date</span>
    </div>
    <div class="date-filters-container">
      <div class="date-picker-row">
        <mat-form-field appearance="outline" class="date-picker-field">
          <input
            matInput
            [matDatepicker]="afterPicker"
            [formControl]="deliveryOnOrAfterDateControl"
            placeholder="DD-MM-YYYY"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="afterPicker"></mat-datepicker-toggle>
          <mat-datepicker #afterPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="filter-actions">
    <button class="reset-all-btn" (click)="resetAll()">Reset All</button>
    <button class="apply-filters-btn" (click)="applyFilters()">Apply Filters</button>
  </div>
</div>

